import { createVNode as o, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RotateRightOutlinedStandard.js";
import d from "../components/PfIcon.js";
const t = (r, e) => {
  const a = {
    ...r,
    ...e.attrs
  };
  return o(d, i(a, {
    icon: n
  }), null);
};
t.displayName = "RotateRightOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
